export default {
  title: 'Mes documents',
  badgeType: 'Documents',
  description: {
    part1: 'Plusieurs',
    part2: 'documents sont disponibles en format électronique',
    part3: 'et d\'autres s\'ajouteront au fur et à mesure de leur disponibilité en format électronique.',
    ariaLabel: 'afficher les documents disponibles.',
    ariaPLabel: 'afficher les documents disponibles en format électronique.',
  },
  documentsTile: {
    title: 'Mes documents',
    text: 'Tous les documents officiels, comme les relevés ou documents fiscaux, sont regroupés au même endroit.',
    link: 'Consulter mes documents',
  },
  modalTitle: 'Documents disponibles en format électronique',
  download: 'Télécharger',
  search: 'Rechercher',
  reset: 'Réinitialiser',
  keyword: 'Mot-clé',
  period: 'Période',
  periodAll: 'Toutes',
  type: 'Type',
  product: 'Produit',
  noDocuments: 'Aucun document',
  noResults: {
    title: 'Aucun document trouvé',
    description: 'Nous n\'avons trouvé aucun document correspondant à votre recherche.',
    suggestions: 'Suggestions :',
    suggestion1: 'Vérifiez l’orthographe des termes de recherche.',
    suggestion2: 'Utilisez des mots clés plus généraux.',
    suggestion3: 'Spécifiez un moins grand nombre de critères de recherche.',
  },
};
